import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad_11DRed_11CBlack = () => <CrossRoad coords="2221.000000, 470.000000" color={tracksColors.red}/>;
export default CrossRoad_11DRed_11CBlack;
